/**
 * 供需列表页面路径
 */
export const SUPPLY_DEMAND_LIST_PAGE_PATH = '/supplyDemand/list'

/**
 * 供需详情页面路径
 */
export const SUPPLY_DEMAND_DETAIL_PAGE_PATH = '/supplyDemand/detail'
